/**
 * Applies css styles defined on column.
 * It ignores custom header rows.
 * 
 * @param {any} row
 * @param {any} col
 * @param {any} cell
 * @param {any} prop
 * @param {any} table 
 * @param {any} cellProperties
 */
export default function (row, col, cell, prop, table, cellProperties) {
    const columns = table.columns;
    if (!columns) {
        return;
    }

    // ignore custom header area
    const customHeaderRows = table.customHeaderRows;
    if (typeof (customHeaderRows) === "number" && row <= customHeaderRows) {
        return;
    }

    const cssClass = (columns[col] || 0).cssClass;
    if (!cssClass) {
        return;
    }

    cellProperties.className = cssClass;
}


// WEBPACK FOOTER //
// ./App/components/Handsontable/cellprocessors/columnCssClassProcessor.js